<div id="error--container">
  <h4>{{ title() }}</h4>
  <div class="subtitle1">{{ primaryText() }}</div>
</div>
